import { Locale } from 'modules/i18n';

export default {
  [Locale.en]: {
    balance: 'Account Balance',
    deposit: 'Deposit',
    withdraw: 'Withdraw',
    walletBalance: 'Wallet Balance: {value} {unit}',
    availableBalance: 'Available Balance: {value} {unit}',
    max: 'Max',
  },
};
